// Reducers
export const constants = {
  UNSET_DATA: 'UNSET_DATA',

  SET_CARS: 'SET_CARS',

  SET_PAYLOAD: 'SET_PAYLOAD',
  UNSET_PAYLOAD: 'CLEAR_PAYLOAD',

  SET_USER: 'SET_USER',
  UNSET_USER: 'UNSET_USER'
}

export const PRODUCT_TYPES = {
  outGoing: 'OUT-GOING',
  inComing: 'IN-COMING'
}

// user types
export const ADMIN = 'ADMIN'
export const MANAGER = 'MANAGER'
export const DELIVERY_GUY = 'DELIVERY-GUY'

// delivery types
export const DELIVERY = 'DELIVERY'
export const PICKUP = 'PICKUP'

// product payment types
export const PAID_FROM_SOURCE = 'PAID-FROM-SOURCE'
export const PAY_ON_DELIVERY = 'PAY-ON-DELIVERY'

export const AIR_SHIPPING = 'AIR-SHIPPING'
export const EXPRESS_AIR_SHIPPING = 'EXPRESS-AIR-SHIPPING'
export const SEA_SHIPPING = 'SEA-SHIPPING'

export const SHIPPING_TYPES = [
  { value: SEA_SHIPPING, label: 'Sea Shipping' },
  { value: AIR_SHIPPING, label: 'Air Shipping' },
  { value: EXPRESS_AIR_SHIPPING, label: 'Express Air Shipping' }
]

export const SHIPPING_NAMES = {
  [SEA_SHIPPING]: 'Free Shipping',
  [AIR_SHIPPING]: 'Standard Shipping',
  [EXPRESS_AIR_SHIPPING]: 'Express Shipping ✨'
}

export const SHIPPING_MONTHS = [
  { value: 'JANUARY', label: 'January' },
  { value: 'FEBRUARY', label: 'February' },
  { value: 'MARCH', label: 'March' },
  { value: 'APRIL', label: 'April' },
  { value: 'MAY', label: 'May' },
  { value: 'JUNE', label: 'June' },
  { value: 'JULY', label: 'July' },
  { value: 'AUGUST', label: 'August' },
  { value: 'SEPTEMBER', label: 'September' },
  { value: 'OCTOBER', label: 'October' },
  { value: 'NOVEMBER', label: 'November' },
  { value: 'DECEMBER', label: 'December' }
]

export const SIZE_TEXT = 'TEXT'
export const SIZE_NUMBER = 'NUMBER'

export const SIZE_TYPES = [
  { value: SIZE_TEXT, label: 'Text' },
  { value: SIZE_NUMBER, label: 'Number' }
]

// messaging types
export const SMS = 'SMS'
export const WHATSAPP = 'WHATSAPP'

export const TASK_TYPES = [
  { value: SMS, label: 'SMS' },
  { value: WHATSAPP, label: 'WhatsApp' }
]

// country choices
export const GHANA = 'gh'
export const COUNTRIES_LIST = [
  { label: 'Ghana', value: GHANA, flag: '🇬🇭', code: '+233' }
]

// network choices
export const MTN = 'MTN'
export const TELECEL = 'TELECEL'
export const AIRTEL_TIGO = 'AIRTEL-TIGO'
export const GLO = 'GLO'

export const NETWORK_CHOICES = [
  { value: MTN, label: 'MTN' },
  { value: TELECEL, label: 'Telecel' },
  { value: AIRTEL_TIGO, label: 'Airtel-Tigo' },
  { value: GLO, label: 'Glo' }
]

// payment statuses
export const INITIALIZED = 'INITIALIZED'
export const SUCCESSFUL = 'SUCCESSFUL'
export const PROCESSING = 'PROCESSING'

export const STATUS_LIST = [
  { value: INITIALIZED, label: 'Initialized' },
  { value: PROCESSING, label: 'Processing' },
  { value: SUCCESSFUL, label: 'Successful' }
]

// payment methods
export const MOBILE_MONEY = 'MOBILE_MONEY'
export const BANK_TRANSFER = 'BANK_TRANSFER'
export const DEBIT_CARD = 'DEBIT_CARD'
export const PAYSTACK = 'PAYSTACK'

export const PAYMENT_METHODS = [
  { value: MOBILE_MONEY, label: 'Mobile Money' },
  { value: BANK_TRANSFER, label: 'Bank Transfer' },
  { value: DEBIT_CARD, label: 'Debit Card' }
]

// currency types
export const CNY = 'CNY'
export const USD = 'USD'
export const GHS = 'GHS'
export const EUR = 'EUR'
export const CAD = 'CAD'
export const AED = 'AED'

export const CURRENCY_LIST = [
  { value: CNY, label: 'Chinese Yuan' },
  { value: USD, label: 'US Dolar' },
  { value: GHS, label: 'Ghana Cedis' },
  { value: EUR, label: 'Euro' },
  { value: CAD, label: 'Canadian Dollar' },
  { value: AED, label: 'UAE Dirham' }
]

export const KM = 'KM'
export const MILES = 'MILES'

export const MILEAGE_UNITS = [
  { value: KM, label: 'Kilometers' },
  { value: MILES, label: 'Miles' }
]

// order status types
export const PENDING = 'PENDING'
export const PAID = 'PAID'

export const ORDERED = 'ORDERED'
export const IN_WAREHOUSE = 'IN-WAREHOUSE'
export const SHIPPED = 'SHIPPED'
export const IN_TRANSIT = 'IN-TRANSIT'
export const LOCAL_CUSTOMS = 'LOCAL-CUSTOMS'
export const ARRIVED = 'ARRIVED'
export const DELIVERED = 'DELIVERED'

export const ORDER_STATUSES = [
  { label: 'Pending', value: PENDING },
  { label: 'Paid', value: PAID }
]

export const ORDER_DELIVERY_STATUSES = [
  { label: 'Pending processing', value: PENDING },
  { label: 'Item ordered', value: ORDERED },
  { label: 'Arrived at the origin warehouse', value: IN_WAREHOUSE },
  { label: 'Shipped from origin warehouse', value: SHIPPED },
  { label: 'On the way to destination country', value: IN_TRANSIT },
  { label: 'Local customs clearing', value: LOCAL_CUSTOMS },
  { label: 'Arrived in the destination warehouse', value: ARRIVED },
  { label: 'Delivered to customer', value: DELIVERED }
]

// User notification types
export const USER_ORDERS_PAYMENT_SUCCESSFUL = 'USER_ORDERS_PAYMENT_SUCCESSFUL'
export const USER_CARS_SHIPPED = 'USER_CARS_SHIPPED'
export const USER_CARS_ARRIVED = 'USER_CARS_ARRIVED'
export const USER_CARS_DELIVERED = 'USER_CARS_DELIVERED'
export const NO_NOTIFICATION = 'NONE'

export const USER_NOTIFICATION_TYPES = [
  {
    value: NO_NOTIFICATION,
    label: 'Do not notify the customer'
  },
  // {
  //   value: USER_ORDERS_PAYMENT_SUCCESSFUL,
  //   label: 'Order payment successful'
  // },
  { value: USER_CARS_SHIPPED, label: 'Product has been shipped' },
  { value: USER_CARS_ARRIVED, label: 'Product has arrived' },
  { value: USER_CARS_DELIVERED, label: 'Product has been delivered' }
]

export const AUTOTRADER_CA = 'SAVE_CAR_FROM_AUTOTRADER'
export const FIRSTCHOICE_AE = 'SAVE_CAR_FROM_FIRSTCHOICE'
export const CARS_US = 'SAVE_CAR_FROM_CARS_US'
export const SBTJAPAN = 'SAVE_CAR_FROM_SBTJAPAN'
export const CNCARGOTOP_CN = 'SAVE_CAR_FROM_CNCARGOTOP'
export const GUAZI_CN = 'SAVE_CAR_FROM_GUAZI'
// Any site we have no parser for: read by the API's generic reader (spec: phone-first-scraping).
export const GENERIC_SITE = 'SAVE_CAR_FROM_GENERIC'

export const CAR_VENDORS = [
  { value: AUTOTRADER_CA, label: 'Autotrader CA' },
  { value: FIRSTCHOICE_AE, label: 'First Choice AE' },
  { value: CARS_US, label: 'Cars US' },
  { value: SBTJAPAN, label: 'SBT Japan' },
  { value: CNCARGOTOP_CN, label: 'CNCargoTop CN' },
  { value: GUAZI_CN, label: 'Guazi CN' },
  // The catch-all stays last: above a named vendor it invites being picked by accident.
  { value: GENERIC_SITE, label: 'Any other site' }
]

// How many times the API's scheduled sweep retries a car task before giving up. Mirrors
// main.constants.MAX_TASK_RETRIES (spec: bot-scrape-tasks).
export const MAX_TASK_RETRIES = 6

// Which rung of the fetch ladder produced a task's page (spec: phone-first-scraping).
export const FETCHER_LABELS = { native: 'Browser', zyte: 'Zyte', file: 'File' }

export const SCRAPING_STAGE_COMPLETED = 'SCRAPING_STAGE_COMPLETED'
export const SCRAPING_STAGE_FAILED = 'SCRAPING_STAGE_FAILED'
export const SAVING_STAGE_COMPLETED = 'SAVING_STAGE_COMPLETED'
export const SAVING_STAGE_FAILED = 'SAVING_STAGE_FAILED'
export const DUPLICATE_CAR_FOUND = 'DUPLICATE_CAR_FOUND'

export const CAR_TASK_STAGES = [
  { value: SCRAPING_STAGE_COMPLETED, label: 'Scraping Completed' },
  { value: SCRAPING_STAGE_FAILED, label: 'Scraping Failed' },
  { value: SAVING_STAGE_COMPLETED, label: 'Saving Completed' },
  { value: SAVING_STAGE_FAILED, label: 'Saving Failed' },
  { value: DUPLICATE_CAR_FOUND, label: 'Duplicate Found' }
]
